import { IRequest } from '@r1-frontend/shared/types/IRequest';

/*
* https://master.api-pay.sandbox.d2c.r-one.io/docs/v1#/Autopayment/778cc353ec5713d3441bab439999f1c2
*
*/

export const deactivateAutopayment = (providerId: number, bindingCardId: number): IRequest => ({
    uri: '/autopayment/deactivate',
    withAuth: true,
    withProvider: true,
    method: 'POST',
    body: JSON.stringify({ binding_id: bindingCardId }),
    queryParams: {
        providerId,
    },
});
